import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { BRAND } from "@/data";

export default function Footer() {
  return (
    <footer className="bg-ink border-t border-gold/15 pt-20 pb-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <img src={BRAND.logo} alt="Peace Trucking" className="h-14 w-14 object-contain" />
              <div>
                <div className="font-serif text-2xl text-cream">Peace Trucking LLC</div>
                <div className="text-[10px] tracking-[0.35em] uppercase text-gold/70">Local · Cross-Country · Care</div>
              </div>
            </div>
            <p className="mt-6 text-cream/55 font-light max-w-md leading-relaxed">
              A Black-owned transport company moving freight, people, and purpose across the nation —
              proudly serving NGOs, care providers, and communities from Lancaster, SC.
            </p>
          </div>

          <div>
            <div className="text-xs tracking-[0.35em] uppercase text-gold/70 mb-5">Contact</div>
            <ul className="space-y-3 text-cream/70 text-sm">
              <li><a href={BRAND.phoneHref} className="flex items-center gap-3 hover:text-gold"><Phone size={15} className="text-gold" />{BRAND.phone}</a></li>
              <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-gold"><Mail size={15} className="text-gold" />{BRAND.email}</a></li>
              <li><a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold"><Instagram size={15} className="text-gold" />@{BRAND.instagram}</a></li>
              <li className="flex items-center gap-3"><MapPin size={15} className="text-gold" />{BRAND.address}</li>
            </ul>
          </div>

          <div>
            <div className="text-xs tracking-[0.35em] uppercase text-gold/70 mb-5">Credentials</div>
            <ul className="space-y-3 text-cream/70 text-sm">
              <li>USDOT <span className="text-cream">{BRAND.dot}</span></li>
              <li>MC <span className="text-cream">{BRAND.mc}</span></li>
              <li className="pt-2"><Link to="/login" className="text-gold link-underline">Client Portal →</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream/40 tracking-wide">
          <span>© {new Date().getFullYear()} Peace Trucking LLC. All rights reserved.</span>
          <span>Founded by {BRAND.owner} · University of Maryland Eastern Shore</span>
        </div>
      </div>
    </footer>
  );
}
